import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TabsTimeline, FormFooter } from 'components';
import { isNil, isEmpty } from 'lodash';
import { steps } from './steps';
import {
  fetchProcInstancesDetailed,
  getApptrackDetails,
  setApptrackLoading,
} from 'store/appTrack/actions';
import { clearForm, getSystemLocales } from 'store/forms/actions';
import { checkUser, getUser } from 'store/user/actions';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { isBeneficiary } from 'utils';

const ViewForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const [activeTask, setActiveTask] = useState('');
  const url = window.location.pathname;
  const id = url.substring(url.lastIndexOf('/') + 1);
  const user = useSelector(state => state.user);
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);

  const isApptrack = url.includes('apptrack');
  const activeForm = useSelector(state => state.activeForm.activeFormId);

  useEffect(() => {
    dispatch(setApptrackLoading());
  }, [activeForm]);

  useEffect(() => {
    dispatch(checkUser(navigate));
    dispatch(getApptrackDetails(id));
  }, []);

  const renderTabs = steps => {
    const tabList = [];
    tabList.push(steps[0], steps[1], steps[2], steps[3], steps[4]);
    return tabList;
  };

  return (
    // pageLoading ?
    false ? (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    ) : (
      <div id="mainforms-page-1" className="investor-form-container">
        {!isNil(current) && (
          <div className="investor-steps-footer-container">
            {isBeneficiary(user?.groups) &&
              apptrackDetails?.activeTaskName ==
                'task.name.application_evaluated' && (
                <div className="stepper-warning-message">
                  <div>
                    Σε περίπτωση που επιθυμείτε να προσθέσετε νέες δαπάνες στο
                    επενδυτικό σας πλάνο, σας ενημερώνουμε ότι δεν είναι δυνατή
                    η τροποποίηση αίτησης που έχει ήδη υποβληθεί. Για τον λόγο
                    αυτό, παρακαλούμε να προχωρήσετε πρώτα στην ακύρωση της
                    τρέχουσας αίτησής σας και στη συνέχεια να υποβάλετε νέα
                    αίτηση με το σύνολο των δαπανών που επιθυμείτε να
                    συμπεριλάβετε.
                  </div>
                </div>
              )}
            <TabsTimeline
              tabs={renderTabs(steps)}
              current={current}
              setCurrent={setCurrent}
              customClass={'custom-tabs-timeline'}
              activeTask={activeTask}
              isApptrack={isApptrack}
            />
            <FormFooter
              tabs={steps}
              current={current}
              setCurrent={setCurrent}
              currentSubTab={currentSubTab}
              isView={true}
            />
          </div>
        )}
      </div>
    )
  );
};

export default ViewForm;
